export type Channel = "shortcut" | "backgroundRequests";

export default class ComponentComunicator {
  private broadcastChannel: BroadcastChannel;

  constructor(channel: Channel) {
    this.broadcastChannel = new BroadcastChannel(channel);
  }

  listenChannel(callback: (event: Event) => void) {
    this.broadcastChannel.addEventListener("message", callback);
  }
  leaveChannel() {
    this.broadcastChannel.close();
  }

  sendToChannel(data: unknown) {
    this.broadcastChannel.postMessage(data);
  }
}
